// TODO: get rid of this.
@import '~@material/ripple/mdc-ripple';
@import '../../style/focus-outline.scss';

:host {
    display: inline-block;

    --wcs-button-color: var(--wcs-button-plain-color-default);
    --wcs-button-plain-color-default: var(--wcs-semantic-color-foreground-action-primary-default);
    --wcs-button-color-disabled: var(--wcs-semantic-color-text-disabled);
    --wcs-button-stroked-color-default: var(--wcs-semantic-color-foreground-action-secondary-default);
    --wcs-button-clear-color-default: var(--wcs-semantic-color-foreground-action-tertiary-default);

    --wcs-button-focus-outline-color: var(--wcs-semantic-color-border-focus-base);
    --wcs-button-focus-outline-border-width: var(--wcs-semantic-border-width-large);

    --wcs-button-background-color: var(--wcs-button-plain-background-color-default);
    --wcs-button-plain-background-color-default: var(--wcs-semantic-color-background-action-primary-default);
    --wcs-button-plain-background-color-disabled: var(--wcs-semantic-color-background-action-primary-disabled);
    --wcs-button-stroked-background-color-default: var(--wcs-semantic-color-background-action-secondary-default);
    --wcs-button-stroked-background-color-disabled: var(--wcs-semantic-color-background-action-secondary-disabled);
    --wcs-button-clear-background-color-default: var(--wcs-semantic-color-background-action-tertiary-default);
    --wcs-button-clear-background-color-disabled: var(--wcs-semantic-color-background-action-tertiary-disabled);

    --wcs-button-ripple-color: var(--wcs-button-plain-ripple-color-default);
    --wcs-button-plain-ripple-color-default: var(--wcs-semantic-color-ripple-action-primary);
    --wcs-button-stroked-ripple-color-default: var(--wcs-semantic-color-ripple-action-secondary);
    --wcs-button-clear-ripple-color-default: var(--wcs-semantic-color-ripple-action-tertiary);
    --wcs-button-border-radius: var(--wcs-button-border-radius-default);
    --wcs-button-border-radius-default: var(--wcs-semantic-border-radius-base);
    --wcs-button-border-radius-rounded: var(--wcs-semantic-border-radius-full);

    --wcs-button-stroked-border-color: var(--wcs-button-stroked-border-color-default);
    --wcs-button-stroked-border-width: var(--wcs-semantic-border-width-default);
    --wcs-button-stroked-border-color-default: var(--wcs-semantic-color-border-action-secondary-default);
    --wcs-button-stroked-border-color-disabled: var(--wcs-semantic-color-border-action-secondary-disabled);

    --wcs-button-height-s: var(--wcs-semantic-size-s);
    --wcs-button-font-size-s: var(--wcs-semantic-font-size-label-2);
    --wcs-button-padding-size-s: calc(1.5 * var(--wcs-semantic-spacing-base));

    --wcs-button-height-m: var(--wcs-semantic-size-m);
    --wcs-button-font-size-m: var(--wcs-semantic-font-size-label-1);
    --wcs-button-padding-size-m: calc(2 * var(--wcs-semantic-spacing-base));

    --wcs-button-height-l: var(--wcs-semantic-size-l);
    --wcs-button-font-size-l: var(--wcs-semantic-font-size-label-1);
    --wcs-button-padding-size-l: calc(3 * var(--wcs-semantic-spacing-base));

    --wcs-button-font-weight: var(--wcs-semantic-font-weight-medium);
}


.wcs-inner-button:focus-visible {
    @include focus-outline($outline-color: var(--wcs-button-focus-outline-color), $border-radius: var(--wcs-button-border-radius), $border-width: var(--wcs-button-focus-outline-border-width));
}

:host([mode=clear]) {
    --wcs-button-stroked-border-color: transparent;

    .wcs-inner-button {
        box-shadow: none;
    }
}

:host([mode=stroked]) {
    --wcs-button-color: var(--wcs-button-stroked-color-default);
    --wcs-button-background-color: transparent;

    .wcs-inner-button {
        &::before,
        &::after {
            --wcs-button-ripple-color: var(--wcs-button-stroked-ripple-color-default);
        }
    }
}

:host([mode=clear]) {
    --wcs-button-color: var(--wcs-button-clear-color-default);
    --wcs-button-background-color: transparent;

    .wcs-inner-button {
        &::before,
        &::after {
            --wcs-button-ripple-color: var(--wcs-button-clear-ripple-color-default);
        }
    }
}

:host([size=l]) {
    --wcs-button-padding: 0 var(--wcs-button-padding-size-l);
    --wcs-button-height: var(--wcs-button-height-l);
    --wcs-button-min-width: var(--wcs-button-height-l);
    --wcs-button-font-size: var(--wcs-button-font-size-l);

    &:host([shape=round]), &:host([shape=square]) {
        ::slotted(wcs-mat-icon) {
            margin: calc(-1 * var(--wcs-button-padding-size-l));
        }
    }
}

:host, :host([size=m]) { // Default
    --wcs-button-padding: 0 var(--wcs-button-padding-size-m);
    --wcs-button-height: var(--wcs-button-height-m);
    --wcs-button-min-width: var(--wcs-button-height-m);
    --wcs-button-font-size: var(--wcs-button-font-size-m);

    &:host([shape=round]), &:host([shape=square]) {
        ::slotted(wcs-mat-icon) {
            margin: calc(-1 * var(--wcs-button-padding-size-m));
        }
    }
}

:host([size=s]) {
    --wcs-button-padding: 0 var(--wcs-button-padding-size-s);
    --wcs-button-height: var(--wcs-button-height-s);
    --wcs-button-min-width: var(--wcs-button-height-s);
    --wcs-button-font-size: var(--wcs-button-font-size-s);

    &:host([shape=round]), &:host([shape=square]) {
        ::slotted(wcs-mat-icon) {
            margin: calc(-1 * var(--wcs-button-padding-size-s));
        }
    }
}

:host([shape=round]) {
    --wcs-button-border-radius: var(--wcs-button-border-radius-rounded);
}

:host([shape=square]) {
    --wcs-button-padding: 0;
}

:host([shape=normal]) {
    .wcs-inner-button {
        min-width: var(--wcs-button-min-width, unset);
        min-height: var(--wcs-button-height, unset);
    }
}

:host([mode=stroked]) {
    .wcs-inner-button {
        box-shadow: inset 0 0 0 var(--wcs-button-stroked-border-width) var(--wcs-button-stroked-border-color);
    }
}

:host([loading]) {
    position: relative;

    .wcs-inner-button > *:not(wcs-spinner) {
        visibility: hidden;
        opacity: 0;
    }

    wcs-spinner {
        --wcs-spinner-dashed-background-circle: var(--wcs-button-color);
        --wcs-spinner-rotating-circle-color: var(--wcs-button-color);
        height: calc(var(--wcs-button-height) / 2);
        width: calc(var(--wcs-button-min-width) / 2);
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
}

:host([disabled]), :host([loading]) {
    cursor: not-allowed;

    .wcs-inner-button {
        opacity: 1;
        cursor: default;
        pointer-events: none;
    }
}



:host([disabled]) {
    --wcs-button-color: var(--wcs-button-color-disabled);
    --wcs-button-background-color: var(--wcs-button-plain-background-color-disabled);
}

:host([mode=stroked][disabled]) {
    --wcs-button-stroked-border-color: var(--wcs-button-stroked-border-color-disabled);
    --wcs-button-background-color: var(--wcs-button-stroked-background-color-disabled);
}

:host([mode=clear][disabled])  {
    --wcs-button-background-color: var(--wcs-button-clear-background-color-disabled);
}

.wcs-inner-button {
    @include mdc-ripple-surface;
    @include mdc-ripple-radius-bounded;
    @include mdc-states-hover-opacity(.1);
    @include mdc-states-focus-opacity(.2);
    @include mdc-states-press-opacity(.3);
    @include mdc-states-base-color(white);
    --mdc-ripple-focus-opacity: 0;

    // This property is used to set the ripple color
    &::before,
    &::after {
        background-color: var(--wcs-button-ripple-color);
    }

    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-family: var(--wcs-font-sans-serif);
    background-color: var(--wcs-button-background-color);
    color: var(--wcs-button-color);
    padding: var(--wcs-button-padding);
    border-radius: var(--wcs-button-border-radius);
    border: none;
    overflow: hidden;
    outline: 0;
    text-transform: none;
    margin: 0;
    cursor: pointer;
    font-weight: var(--wcs-button-font-weight);
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    font-size: var(--wcs-button-font-size);
    line-height: 1.5;
    height: var(--wcs-button-height);
    min-width: var(--wcs-button-min-width);

    transition: color 175ms ease-in-out, background-color 175ms ease-in-out;
}

a {
    text-decoration: none;
    box-sizing: border-box;
}

// Remove mozilla dotted outline on button and a
button::-moz-focus-inner,
a::-moz-focus-inner {
    border: 0;
}
